<template>
  <header class="site-header">
    <div class="container site-header-inner">
      <router-link to="/" class="brand" aria-label="Ir para a página inicial">
        <span class="brand-mark" aria-hidden="true">E</span>
        <span class="brand-text">
          <strong>EasySaúde</strong>
          <small>Gestão para clínicas</small>
        </span>
      </router-link>

      <nav class="nav" aria-label="Navegação principal">
        <a href="/#formulario">Contato</a>
        <router-link to="/politica-privacidade">Política de privacidade</router-link>
        <a :href="appLoginUrl" target="_blank" rel="noopener noreferrer">Acesso do cliente</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    appLoginUrl: { type: String, required: true }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(12px);
  background: rgba(248, 250, 252, 0.82);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.site-header-inner {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
}

.brand-mark {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #fff;
  background: linear-gradient(135deg, var(--easy-green), var(--easy-green-2));
  box-shadow: 0 10px 20px rgba(77, 186, 135, 0.25);
}

.brand-text {
  display: grid;
  line-height: 1.1;
}

.brand-text strong {
  font-size: 15px;
}

.brand-text small {
  color: var(--easy-muted);
  font-size: 12px;
}

.nav {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.nav a {
  color: var(--easy-muted);
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 1px solid transparent;
}

.nav a:hover,
.nav a.router-link-active {
  color: var(--easy-dark);
  border-bottom-color: rgba(77, 186, 135, 0.75);
}

@media (max-width: 820px) {
  .site-header-inner {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .nav {
    gap: 14px;
  }
}
</style>
